
import React from 'react';
import UserProfile from '@/components/auth/UserProfile';

const Settings: React.FC = () => {
  return <UserProfile />;
};

export default Settings;
